import React, { useState } from "react";
import { ToastContainer } from "react-toastify";

const DiscountTab = ({ data, onDelete, onUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [formData, setFormData] = useState({
    discount: "",
    chargeType: "fixed",
    orderType: "homeDelivery",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateDiscount = async (e) => {
    e.preventDefault();

    if (!formData.discount) {
      alert("Please enter discount");
      return;
    }

    const res = await onUpdate({
      discount: formData.discount,
      chargeType: formData.chargeType,
      orderType: formData.orderType,
    });

    if (res !== null) {
      setFormData({
        discount: "",
        chargeType: "fixed",
        orderType: "homeDelivery",
      });
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedItem) return;

    const res = await onDelete(selectedItem.id);

    if (res !== null) {
      setShowModal(false);
      setSelectedItem(null);
    }
  };

  return (
    <>
    <ToastContainer/>
   
    <div className="montserrat-font-1">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Side Discount List */}
       <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
          {data?.length > 0 ? (
            data.map((item, index) => (
              <div
                key={index}
                className="bg-white border rounded-xl p-5 shadow-sm"
              >
                <div className="flex justify-between items-center mb-3">
                  <h2 className="text-green-600 font-semibold">
                    Currently Applied Discount
                  </h2>

                  <button
                    onClick={() => {
                      setSelectedItem(item);
                      setShowModal(true);
                    }}
                    className="bg-red-500 hover:bg-red-600 text-white text-xs px-3 py-1 rounded-md"
                  >
                    Remove
                  </button>
                </div>

                <div className="border-t pt-3 text-sm space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Discount:</span>
                    <span className="font-medium">
                      {item.discountType === "fixed" ? "₹" : ""}
                      {parseFloat(item.discount || 0).toFixed(2)}
                      {item.discountType !== "fixed" ? "%" : ""}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Discount Type:</span>
                    <span className="font-medium">
                      {item.discountType || item.chargeType}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Order Type:</span>
                    <span className="font-medium">{item.orderType}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="bg-white border rounded-xl p-6 text-center text-gray-500">
              No discounts found
            </div>
          )}
        </div>

        {/* Right Side Update Form */}
        <div className="lg:col-span-1">
          <form
            onSubmit={handleUpdateDiscount}
            className="bg-white border rounded-xl p-5 shadow-sm sticky top-4"
          >
            <h2 className="text-green-600 font-semibold mb-4">
              Update Discount
            </h2>

            <div className="space-y-4">
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">
                  Discount
                </label>
                <input
                  type="number"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  placeholder="Enter discount"
                  className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">
                  Charge Type
                </label>
                <select
                  name="chargeType"
                  value={formData.chargeType}
                  onChange={handleChange}
                  className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-green-500"
                >
                  <option value="fixed">Fixed</option>
                  <option value="percentage">Percentage</option>
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">
                  Order Type
                </label>
                <select
                  name="orderType"
                  value={formData.orderType}
                  onChange={handleChange}
                  className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-green-500"
                >
                  <option value="homeDelivery">Home Delivery</option>
                  <option value="takeaway">Takeaway</option>
                  <option value="dinein">Dine In</option>
                </select>
              </div>

              <button
                type="submit"
                className="w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md text-sm"
              >
                Update Discount
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Delete Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-xl p-6 w-[350px] shadow-lg">
            <h2 className="text-lg font-semibold mb-3 text-red-600">
              Confirm Delete
            </h2>

            <p className="text-sm text-gray-600 mb-4 montserrat-font-2">
              Are you sure you want to delete this discount?
            </p>

            <div className="bg-gray-50 p-3 rounded mb-4 text-sm">
              <div className="flex justify-between">
                <span>Discount:</span>
                <span className="font-medium">{selectedItem?.discount}</span>
              </div>

              <div className="flex justify-between mt-1">
                <span>Type:</span>
                <span className="font-medium">
                  {selectedItem?.discountType || selectedItem?.chargeType}
                </span>
              </div>

              <div className="flex justify-between mt-1">
                <span>Order Type:</span>
                <span className="font-medium">{selectedItem?.orderType}</span>
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="px-3 py-1 text-sm border rounded-md"
              >
                Cancel
              </button>

              <button
                onClick={handleConfirmDelete}
                className="px-3 py-1 text-sm bg-red-500 text-white rounded-md"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default DiscountTab;
